<script setup>
import { VueFlow } from '@vue-flow/core';
import '@vue-flow/core/dist/style.css';
import '@vue-flow/core/dist/theme-default.css';

defineProps({
  nodes: {
    type: Array,
    default: () => [],
  },
  edges: {
    type: Array,
    default: () => [],
  },
});

const emit = defineEmits([
  'update:nodes',
  'update:edges',
  'nodeClick',
  'edgeClick',
  'paneClick',
  'nodeDragStop',
  'connect',
]);

const onNodesChange = nodes => {
  emit('update:nodes', nodes);
};

const onEdgesChange = edges => {
  emit('update:edges', edges);
};

const onNodeClick = payload => {
  const node = payload?.node || payload;
  if (node?.id) emit('nodeClick', node);
};

const onEdgeClick = payload => {
  const edge = payload?.edge || payload;
  if (edge?.id) emit('edgeClick', edge);
};
</script>

<template>
  <div class="w-full h-full min-h-[420px] bg-n-background">
    <VueFlow
      :nodes="nodes"
      :edges="edges"
      nodes-draggable
      nodes-connectable
      elements-selectable
      :fit-view-on-init="false"
      :min-zoom="0.2"
      :max-zoom="1.5"
      :default-viewport="{ x: 48, y: 24, zoom: 0.85 }"
      class="onix-flow-canvas w-full h-full"
      @update:nodes="onNodesChange"
      @update:edges="onEdgesChange"
      @node-click="onNodeClick"
      @edge-click="onEdgeClick"
      @pane-click="() => emit('paneClick')"
      @node-drag-stop="() => emit('nodeDragStop')"
      @connect="params => emit('connect', params)"
    >
      <template #node-default="{ label }">
        <div class="px-3 py-2 text-sm leading-5 text-n-slate-12 max-w-56">
          {{ label }}
        </div>
      </template>
    </VueFlow>
  </div>
</template>
